import { Suspense } from 'react';
import { DelayedLoadingSpinner } from './DelayedLoadingSpinner';

export const Loadable = <T extends object>({
  Component,
}: {
  Component: React.FC<T>;
}) => {
  const WrappedComponent = (props: T) => (
    <Suspense fallback={<DelayedLoadingSpinner />}>
      <Component {...props} />
    </Suspense>
  );

  return WrappedComponent;
};
